import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_danh_muc_ban_hang_gia_ban_C_p_nh_t_gi__b_n } from '@/lib/templates-base64/GIA-BAN';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import type { GiaBanV2 } from '@/types/schemas';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick: (rowData?: GiaBanV2 | null) => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: (rowData?: GiaBanV2 | null) => void;
  onWatchIconClick: (rowData?: GiaBanV2 | null) => void;
  onImportFromExcel?: () => void;
  selectedObj?: GiaBanV2 | null;
  isEditDisabled?: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onImportFromExcel,
  selectedObj,
  isEditDisabled = true
}) => {
  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(excelTemplate_danh_muc_ban_hang_gia_ban_C_p_nh_t_gi__b_n, 'Cập nhật giá bán.xlsx');
  };

  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Cập nhật giá bán</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} />
      <ActionButtonV2
        icon={Pencil1Stroke}
        title='Sửa'
        onClick={() => onEditIconClick(selectedObj)}
        disabled={!selectedObj || isEditDisabled}
      />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteIconClick} disabled={!selectedObj} />
      <ActionButtonV2
        icon={FileMultipleStroke}
        title='Sao chép'
        onClick={() => onCopyIconClick(selectedObj)}
        disabled={!selectedObj}
      />
      <ActionButtonV2
        icon={EyeStroke}
        title='Xem'
        onClick={() => onWatchIconClick(selectedObj)}
        disabled={!selectedObj}
      />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => onImportFromExcel && onImportFromExcel(),
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
